export function hamburger() {
  const hamburger = document.querySelector('.js-hamburger');
  const hamburgerNav = document.querySelector('.js-hamburgerNav');
  const hamburgerLinks = document.querySelectorAll('.js-hamburgerLink');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('is-active');
    hamburgerNav.classList.toggle('is-active');
  });

  hamburgerLinks.forEach(element => {
    element.addEventListener('click', () => {
      hamburger.classList.remove('is-active');
      hamburgerNav.classList.remove('is-active');
    })
  });
}